import store from "./store";
import router from "./router"
import vue from "vue"
import NProgress from "nprogress"
import "nprogress/nprogress.css"

const whiteList = ['/login', '/forgotPassword', '/register', '/table']//设置白名单
let loadRouter = false
router.beforeEach((to, from, next) => {
  NProgress.start();
  if (vue.ls.get('token')) {
    if (to.path == '/login') {
      next();
    } else {
      if (!loadRouter) {
        store.dispatch('getAddRouterData').then(() => {
          loadRouter = true;
          let item = store.getters.addRouter
          for (var i = 0; i < item.length; i++) {//addroute只能添加对象，这里要遍历一下
            router.addRoute('layout', item[i])
          }
          next({ ...to, replace: true });
        })
      } else {
        next();
      }
    }
  } else {
    if (whiteList.indexOf(to.path) !== -1) {
      loadRouter = false
      next()
    } else {
      loadRouter = false
      next({ path: '/login', replace: true })
      NProgress.done()
    }
  }
})

router.afterEach(() => {
  NProgress.done()
})